var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 507,
    viewBox: "0 0 516 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Usuario") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\xCDcono simple de usuario con cabeza circular y cuerpo semicircular.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 134,
    r: 116
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 486C31 371.3 124.3 278 239 278H277C391.7 278 485 371.3 485 486H31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChat);
export default __webpack_public_path__ + "static/media/user-chat.9ef434c1a564a1283427d91318a1ce51.svg";
export { ForwardRef as ReactComponent };